module.exports = __webpack_public_path__ + "images/tower_naming_diag-39cdae93f0a4e81d3f50d8fd76718e6d.gif";